import {
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { ContentStyle, DataGridListStyle, SearchBox } from "../../Theme";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import NoRecords from "../../components/NoRecords";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import ErrorOverlay from "../../components/ErrorOverlay";
import { v4 as uuid } from "uuid";
import useFetch from "../../CustomHooks/useFetch";
import { useEffect, useState } from "react";
import useDebounce from "../../CustomHooks/useDebounce";
import { templatePrescriptionList } from "../../Apis/TemplateApis";
import { useNavigate } from "react-router-dom";

export default function PrescriptionTemplate() {
  const [templateName, setTemplateName] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const templateDebouncedValue = useDebounce(templateName, 1000);
  const navigate = useNavigate();
  const params = {
    doctorId: localStorage.getItem("doctorId"),
    templateName: templateDebouncedValue,
    pageNumber: page,
    pageSize: pageSize,
  };
  const { data, loading, error }: any = useFetch(
    params,
    templatePrescriptionList,
    [templateDebouncedValue, page]
  );

  const columns: GridColDef[] = [
    {
      field: "templateName",
      headerName: "Templates",
      width: 350,
      cellClassName: "w40",
      headerClassName: "w40",
    },
    {
      field: "count",
      headerName: "Count",
      width: 310,
      cellClassName: "w30",
      headerClassName: "w30",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w30",
      headerClassName: "w30",

      renderCell: ({ row }) => {
        return (
          <>
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(`${row?.id}`);
                }}
              >
                <img src={ShowPasswordIcon} alt="Show" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);
  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          {" "}
          <Grid item xs={12}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Prescription Template
              <HelpGuideTooltip
                content={
                  <>
                    <Typography component="div" variant="body1">
                      Prescription template
                    </Typography>
                  </>
                }
              />
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={1}
            alignItems="top"
            justifyContent="flex-start"
            marginBottom={1}
          >
            <Grid item xs={12} md={7} textAlign={"left"}>
              <SearchBox className="searchicon">
                <Typography component="label" color="primary" variant="body2">
                  Search by
                </Typography>{" "}
                <TextField
                  id="drugname"
                  name="DrugName"
                  variant="outlined"
                  placeholder="Enter template name"
                  onChange={(e) => {
                    setTemplateName(e.target.value);
                  }}
                />{" "}
              </SearchBox>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={data[0]?.items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columns}
                autoHeight
                rowHeight={40}
                disableSelectionOnClick
                getRowId={(row) => row.id ?? uuid()}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                rowsPerPageOptions={[10]}
                loading={loading}
                error={error || undefined}
                paginationMode="server"
                page={page}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
                getRowClassName={(params) => {
                  if (params.row.obsoleteDrug) {
                    return "OP";
                  }
                  return "";
                }}
              />
            </DataGridListStyle>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
